
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ContentTable } from "../ContentTable";
import { ContentItem, PaginationState } from "../types";

interface ContentListProps {
  content: ContentItem[];
  isLoading: boolean;
  onChangeCredits: (contentId: number, newCredits: number) => void;
  onToggleVisibility: (contentId: number) => void;
  onTogglePremiere: (contentId: number) => void;
  onDeleteContent: (contentId: number) => void;
  pagination: PaginationState;
  onPageChange: (page: number) => void;
}

export function ContentList({
  content,
  isLoading,
  onChangeCredits,
  onToggleVisibility,
  onTogglePremiere,
  onDeleteContent,
  pagination,
  onPageChange
}: ContentListProps) {
  return (
    <Card className="md:col-span-2">
      <CardHeader>
        <CardTitle>Λίστα Περιεχομένου</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="text-center py-8">Φόρτωση περιεχομένου...</div>
        ) : (
          <ContentTable
            content={content}
            onChangeCredits={onChangeCredits}
            onToggleVisibility={onToggleVisibility}
            onTogglePremiere={onTogglePremiere}
            onDeleteContent={onDeleteContent}
            pagination={pagination}
            onPageChange={onPageChange}
          />
        )}
      </CardContent>
    </Card>
  );
}
